module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_25-8c3ca8b3f1c92edb49d86514b6a5e05a.jpg";